import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      color: palette.text.secondary,
      fontWeight: 600,
      fontSize: '0.6rem'
    },
    item: {
      height: '50px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '4px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
